import hotelPriceRulesConstants from '@utils/constants/hotelPriceRules';
import dateUtils from '@utils/dateUtils';

export function isAboutToEnd(rule) {
    if (rule && rule.to && isActive(rule)) {
        const days = daysTillEnd(rule);

        return days <= hotelPriceRulesConstants.DAYS_TO_END && days >= 0;
    }

    return false;
}

export function daysTillEnd(rule) {
    if (rule && rule.to) {
        return dateUtils.calendarDaysToDate(rule.to);
    }
    return 0;
}

export function isAboutToStart(rule) {
    if (rule && rule.from && isInactive(rule)) {
        const days = daysTillStart(rule);

        return days <= hotelPriceRulesConstants.DAYS_TO_START && days >= 0;
    }
    return false;
}

export function daysTillStart(rule) {
    if (rule && rule.from) {
        return dateUtils.calendarDaysToDate(rule.from);
    }
    return false;
}

export function requiresAttention(rule) {
    return isAboutToEnd(rule) || isAboutToStart(rule);
}

export function isActive(rule) {
    return rule.status === hotelPriceRulesConstants.STATUS.TYPES.ACTIVE;
}

export function isPending(rule) {
    return rule.status === hotelPriceRulesConstants.STATUS.TYPES.PENDING;
}

export function isInactive(rule) {
    return rule.status === hotelPriceRulesConstants.STATUS.TYPES.INACTIVE;
}

export function isExpired(rule) {
    return rule.status === hotelPriceRulesConstants.STATUS.TYPES.EXPIRED;
}

/**
 * Sort two rules by expire, become active and id
 * First expire ( order by id desc )
 * Second become active ( order by id desc )
 * all other order by id desc
 * @param {*} a
 * @param {*} b
 * @returns number
 * < 0 a then b
 * > 0 b then a
 * = 0 original sort
 */
export function compareFNSortByExpireAndActivate(a, b) {
    if (a.id > b.id) {
        if (isAboutToEnd(a)) {
            return -1;
        }

        if (isAboutToEnd(b)) {
            return 1;
        }

        if (isAboutToStart(a)) {
            return -1;
        }

        if (isAboutToStart(b)) {
            return 1;
        }

        return -1;
    }

    return 1;
}
